import { render } from "./notice-list.vue?vue&type=template&id=1d21a7aa&scoped=true&ts=true"
import script from "./notice-list.vue?vue&type=script&lang=ts"
export * from "./notice-list.vue?vue&type=script&lang=ts"

import "./notice-list.vue?vue&type=style&index=0&id=1d21a7aa&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d21a7aa"]])

export default __exports__